import { parseResponse } from '@tableau/metrics-engine';

import { Loadable } from '~src/httpClient/utils/Loadable';

import { MetricsDataAction, MetricsDataActionTypes } from '../actions/MetricsDataActions';
import { notLoadedData } from '../selectors';
import { LoadableDataPointsById } from '../state/MetricsDataState';

export const metricsDataReducer = (
  state: LoadableDataPointsById = {},
  action?: MetricsDataAction
): LoadableDataPointsById => {
  switch (action?.type) {
    case MetricsDataActionTypes.REQUEST_START: {
      const stateToAdd: LoadableDataPointsById = {};
      const idsToLoad = notLoadedData(state, action.ids);
      idsToLoad.forEach((id) => {
        stateToAdd[id] = Loadable.loading({});
      });
      return { ...state, ...stateToAdd };
    }
    case MetricsDataActionTypes.REQUEST_SUCCEEDED: {
      const stateToAdd: LoadableDataPointsById = {};
      Object.entries(action.dataPointsById).forEach(([key, value]) => {
        const parsedResponse = parseResponse(value);
        if (parsedResponse.isOk()) {
          stateToAdd[key] = Loadable.loaded(parsedResponse.unwrap());
        } else {
          stateToAdd[key] = Loadable.failed(parsedResponse.unwrapErr().message);
        }
      });
      return { ...state, ...stateToAdd };
    }
    case MetricsDataActionTypes.REQUEST_FAILED: {
      const stateToAdd: LoadableDataPointsById = {};
      Object.entries(action.failuresById).forEach(([key, value]) => {
        stateToAdd[key] = Loadable.failed(value.message, undefined);
      });
      return { ...state, ...stateToAdd };
    }
    case MetricsDataActionTypes.CLEAR: {
      return {};
    }
    case undefined:
    default:
      return state;
  }
};
